/* template */
<template><div class="station"><div :style="[(headerStyle)] | transRpxStyle" class="header"><mpx-view :class="({ active_left: isActive === orderArr[0]})" @tap="changeTab(orderArr[0])" class="tab tab_left">{{showTab.left_title}}</mpx-view><mpx-view :class="({ active_right: isActive === orderArr[1] })" @tap="changeTab(orderArr[1])" class="tab tab_right">{{showTab.right_title}}</mpx-view></div><div class="content"><gas-list v-show="(isActive === 'gas')" :list="(list)" :styleConfig="(styleConfig)" :showFooterBtn="(showFooterBtn)" @toGuide="toGuide"/><car-wash-list v-show="(isActive === 'car')" :list="(carList)" :styleConfig="(styleConfig)" :showFooterBtn="(showFooterBtn)" @goToDetail="goToDetail"/><div class="placehoder" v-if="(!requested && isActive === 'gas')"><div v-for="(item, index) in (requestParams.limit)" :key="item" :class='("item "+(list.length - 1 === index && !showFooterBtn ? "no-border" : ""))' :style="[(itemStyle)] | transRpxStyle"></div></div><div class="placehoder" v-if="(!requestedCar && isActive === 'car')"><div v-for="(item, index) in (requestParams.limit)" :key="item" :class='("item "+(carList.length - 1 === index && !showFooterBtn ? "no-border" : ""))' :style="[(itemStyle)] | transRpxStyle"></div></div><div class="footer" v-if="(showFooterBtn)"><mpx-view @tap="footerBtnClick(isActive)" :style="[(footerBtnStyle)] | transRpxStyle" class="button">{{isActive === 'gas' ? '查看附近更多油站' : '查看附近更多洗车店'}}</mpx-view></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m54230687"}'>
@font-face {
  font-family: 'DIN-BlackItalic';
  src: url('https://img-hxy021.didistatic.com/static/utfe/do1_l1Sw5zCiLssbdzlZQI12');
}
.station
  .header
    display flex
    background-color: rgba(255,157,66,0.70);
    border-top-left-radius: 30rpx
    border-top-right-radius: 30rpx
    overflow: hidden
    background-size: auto 100%
    background-repeat: no-repeat
    // padding 0 38rpx 4rpx
    box-sizing border-box
    height 80rpx
    line-height 80rpx
    font-family: PingFangSC-Medium;
    font-weight: bold
    font-size: 36rpx;
    color: #ffffff;
    font-weight: 500
    letter-spacing: 0;
    margin-bottom: -1px; // iphoneX屏幕 header和content的div有空隙
    .tab
      width: 365rpx
      background-size: auto 100%
      background-repeat: no-repeat
    .tab_left
      padding-left: 40rpx;
      &.active_left
        width: 375rpx
        color: rgba(224,45,24,1);
        background-image url('https://ut-static.udache.com/webx/ut/lvqsyBxf2yErfELWr3R9B.png')
    .tab_right
      text-align center
      &.active_right
        // padding-left: 100rpx;
        width: 462rpx
        color: rgba(224,45,24,1);
        background-image url('https://ut-static.udache.com/webx/ut/6bQ3LIAsp7m_GzaAYxC-C.png')
  .footer
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 26rpx;
    color: #FF4628;
    margin 33rpx 0 35rpx
    .button
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Regular;
      font-size: 26rpx;
      color: #B6631D;
    .icon-arrow
      margin-left 8rpx
      width: 0
      height: 0;
      border-left: 20rpx solid red;
      border-bottom: 10rpx solid transparent;
      border-top: 10rpx solid transparent;
  .content
    padding 24rpx 38rpx 4rpx
    background: #FFFFFF;
    border-radius: 0 0 30rpx 30rpx
    .placehoder .item
      height 136rpx
    .item
      padding 48rpx 0 52rpx 0
      border-bottom: 1px dashed #C63200;
      &.no-border
        border-bottom none
      .item-header
        display flex
        margin-bottom 20rpx
        .item-name
          flex 1
        .item-name, .item-distance
          font-family: PingFangSC-Medium;
          font-size: 34rpx;
          font-weight: 600
          color: #1B1B1B;
        .item-distance, .item-guide
          display inline-block
        .item-guide
          font-family: PingFangSC-Regular;
          font-size: 26rpx;
          color: #000000;
          padding-left 18rpx
          .icon-guide
            position relative
            top 2rpx
            right 2rpx
            width 26rpx
      .item-desc
        font-family: PingFangSC-Medium;
        font-weight: 600
        font-size: 22rpx;
        color: #4E4E4E;
        line-height: 21rpx;
      .item-price
        display flex
        align-items: baseline;
        margin-top 32rpx
        color: #B6631D;
        .label
          font-family: PingFangSC-Medium;
          font-weight: 600
          font-size: 22rpx;

        .price-vip > .value
          font-family: DIN-BlackItalic;
          font-weight: bold
          font-size: 52rpx;
          color: #FF4628;
          letter-spacing: 0;
          line-height: 52rpx;
          position relative
          bottom -4rpx
          .unit
            padding-right 8rpx
            font-size: 40rpx;
        .price-original
          padding-left 23rpx
          .value
            font-family: PingFangSC-Medium;
            font-weight: 600
            font-size: 22rpx;
          .unit
            padding-right 6rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m54230687"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex54230687%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../../webpack-config-fin/lib/business/webp-loader.js!./index.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Findex54230687%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m54230687"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index54230687/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'gas-list':getComponent(require("./gas-list.mpx?isComponent&outputPath=components%2Fgas-list91bed5aa%2Findex")),'car-wash-list':getComponent(require("./car-wash-list.mpx?isComponent&outputPath=components%2Fcar-wash-list6c16c8f0%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
